import { useState, useRef, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import Toaster, { ToastContainerComponent } from "../components/Toaster";
import FullScreenLoader from "../components/FullScreenLoader";
import { loginApi } from "../utils/api";
import { useNavigate, Link } from "react-router-dom";
import CookieConsent from "../components/CookieConsent";
import { generateCaptcha } from "../utils/captcha"; // Import the captcha generator

const SignIn = () => {
  const [loading, setLoading] = useState(false); // Local loading state
  const [captcha, setCaptcha] = useState(generateCaptcha(6)); // Initial CAPTCHA
  const [captchaInput, setCaptchaInput] = useState(""); // CAPTCHA input state
  const navigate = useNavigate();


  // capctha
  // const CaptchaCanvas = ({ captcha, resetCaptcha }) => {
  const canvasRef = useRef(null);

  // useEffect(() => {
  //   const canvas = canvasRef.current;
  //   const ctx = canvas.getContext("2d");

  //   // Clear canvas
  //   ctx.clearRect(0, 0, canvas.width, canvas.height);

  //   // Background
  //   ctx.fillStyle = "#f0f0f0";
  //   ctx.fillRect(0, 0, canvas.width, canvas.height);

  //   // CAPTCHA Text
  //   ctx.font = "24px 'Courier New', Courier, monospace";
  //   ctx.fillStyle = "#333";

  //   // Add a bit of randomness
  //   const x = 10;
  //   const y = 30;

  //   for (let i = 0; i < captcha.length; i++) {
  //     const letter = captcha[i];
  //     const rotation = (Math.random() - 0.5) * 0.4; // Rotate between -0.2 to 0.2 radians
  //     ctx.save();
  //     ctx.translate(x + i * 24, y);
  //     ctx.rotate(rotation);
  //     ctx.fillText(letter, 0, 0);
  //     ctx.restore();
  //   }

  //   // Add some lines/noise
  //   for (let i = 0; i < 3; i++) {
  //     ctx.beginPath();
  //     ctx.moveTo(Math.random() * 100, Math.random() * 40);
  //     ctx.lineTo(Math.random() * 100, Math.random() * 40);
  //     ctx.strokeStyle = "#ccc";
  //     ctx.stroke();
  //   }
  // }, [captcha]);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    // Clear canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Background
    ctx.fillStyle = "#f0f0f0";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // CAPTCHA Text (Black)
    ctx.font = "bold 26px 'Courier New', Courier, monospace";
    ctx.fillStyle = "#000";

    for (let i = 0; i < captcha.length; i++) {
      const letter = captcha[i];
      const rotation = (Math.random() - 0.5) * 0.6;
      ctx.save();
      ctx.translate(20 + i * 20, 30);
      ctx.rotate(rotation);
      ctx.fillText(letter, 0, 0);
      ctx.restore();
    }

    // More black lines
    for (let i = 0; i < 20; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.strokeStyle = "rgba(0, 0, 0, 0.3)";
      ctx.lineWidth = 1;
      ctx.stroke();
    }

    // More black dots
    for (let i = 0; i < 100; i++) {
      const x = Math.random() * canvas.width;
      const y = Math.random() * canvas.height;
      ctx.fillStyle = "rgba(0, 0, 0, 0.2)";
      ctx.beginPath();
      ctx.arc(x, y, 1.2, 0, 2 * Math.PI);
      ctx.fill();
    }
  }, [captcha]);





  const handleLogin = async (values, actions) => {
    if (!values.email || !values.password) {
      Toaster.error("Please provide email & password.");
      actions.setSubmitting(false);
      return;
    }
    if (captchaInput !== captcha) {
      Toaster.error("Incorrect CAPTCHA. Please try again.");
      resetCaptcha();
      actions.setSubmitting(false);
      return;
    }
    setLoading(true); // Show loader
    try {
      await loginApi(values.email, values.password);
      sessionStorage.setItem("getEmail", values.email);
      navigate("/otp-auth");
    } catch (error) {
      Toaster.error("Login failed. Please check your credentials.");
    } finally {
      setLoading(false); // Hide loader after request
      actions.setSubmitting(false);
    }
  };

  const resetCaptcha = () => {
    setCaptcha(generateCaptcha(6)); // Reset CAPTCHA
    setCaptchaInput(""); // Clear the input field
  };

  return (
    <>
      <FullScreenLoader loading={loading} />
      <div className="login_page">
        <ToastContainerComponent />
        <div className="login">
          <div className="login_left">
            <div className="login_box">
              <h2>Login</h2>
              <Formik
                initialValues={{ username: "", password: "" }}
                onSubmit={(values, actions) => {
                  handleLogin(values, actions);
                }}
              >
                {({ isSubmitting }) => (
                  <Form className="login_form">
                    <div className="input_field">
                      <Field
                        className="form_control"
                        type="text"
                        name="email"
                        placeholder="Username"
                      />
                      <span className="icon">
                        <i className="fa-solid fa-user"></i>
                      </span>
                    </div>
                    <div className="input_field">
                      <Field
                        className="form_control"
                        type="password"
                        name="password"
                        placeholder="Password"
                      />
                      <span className="icon">
                        <i className="fa-solid fa-key"></i>
                      </span>
                    </div>

                    {/* CAPTCHA */}
                    <div className="input_field">
                      <label htmlFor="captcha">Enter the CAPTCHA</label>
                      <Field
                        className="form_control"
                        type="text"
                        name="captcha"
                        placeholder="Enter CAPTCHA"
                        value={captchaInput}
                        onChange={(e) => setCaptchaInput(e.target.value)}
                      />
                    </div>

                    <div className="captcha-display" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <canvas
                        ref={canvasRef}
                        width={150}
                        height={40}
                        style={{ border: "1px solid #ccc", background: "#f9f9f9" }}
                      />
                      <button
                        type="button"
                        className="reset-captcha-btn"
                        onClick={resetCaptcha}
                        title="Refresh CAPTCHA"
                      >
                        <i className="fa fa-refresh" aria-hidden="true"></i>
                      </button>
                    </div>
                    {/* <div className="captcha-display">
                      <strong>{captcha}</strong>
                      Reset CAPTCHA Button
                      <button
                        type="button"
                        className="reset-captcha-btn"
                        onClick={resetCaptcha}
                      >
                        <i className="fa fa-refresh" aria-hidden="true"></i>
                      </button>
                    </div> */}
                    <div className="check">
                      <label className="cl-checkbox">
                        <input type="checkbox" />
                        <span>Remember me</span>
                      </label>
                      <div className="forget_btn">
                        <Link to="/forgot-password">
                          <span>Forgot Password?</span>
                        </Link>
                      </div>
                    </div>

                    <button
                      type="submit"
                      className="login_btn"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Logging in..." : "Login"}
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
          <div className="login_right">
            <div className="logo">
              <img src="./images/logo.png" alt="Logo" />
            </div>
            <h2>
              Welcome! <br /> 1st Choice Formation
            </h2>
          </div>
        </div>
        <CookieConsent />
      </div>
    </>
  );
};

export default SignIn;
